import Grid from '@mui/material/Grid';
import { useDispatch, useSelector } from 'react-redux';

import DateRangePickerFieldWithLimit from 'common/forms/DateRangePickerFieldWithLimit';
import { updateFillLaterFilter } from 'store/thunks/workQueueThunks';

/**
 * Scheduled Date Range - the same outer picker the Bulk tab uses for its Date Range, dispatching
 * `scheduledAt` (single day) / `scheduledBetween` (range) exactly as Bulk dispatches
 * `createdAt` / `createdBetween`. Future dates are allowed: that is where scheduled items live.
 */
const FillLaterQueueOuterFilter = () => {
  const dispatch = useDispatch();
  const filter = useSelector(({ workQueue }) => workQueue.fillLater.filter);

  const onHandleDateChange = (dateRange) => {
    const scheduledAt = dateRange?.length === 1 ? dateRange[0] : undefined;
    const scheduledBetween = !scheduledAt && dateRange?.length === 2 ? dateRange : undefined;

    dispatch(updateFillLaterFilter({ filter: { ...filter, scheduledAt, scheduledBetween } }));
  };

  return (
    <Grid container alignItems='center'>
      <Grid item sx={{ mr: 2 }}>
        <DateRangePickerFieldWithLimit
          label='Scheduled Date Range'
          onDateChange={onHandleDateChange}
          initialValue={filter?.scheduledAt ? [filter.scheduledAt] : filter?.scheduledBetween}
          maxMonths={3}
        />
      </Grid>
    </Grid>
  );
};

export default FillLaterQueueOuterFilter;
